import { render, staticRenderFns } from "./MobileMenuWrapper.vue?vue&type=template&id=58c538a4&scoped=true"
import script from "./MobileMenuWrapper.vue?vue&type=script&lang=js"
export * from "./MobileMenuWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c538a4",
  null
  
)

export default component.exports